import { useTranslation } from 'react-i18next';

/** Accessible loading indicator. `label` defaults to the translated "Memuat...". */
export default function Spinner({ className = 'h-6 w-6', label }) {
  const { t } = useTranslation();
  return (
    <span role="status" className="inline-flex items-center">
      <svg
        className={`${className} motion-safe:animate-spin`}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
        <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      </svg>
      <span className="sr-only">{label || t('common.loading')}</span>
    </span>
  );
}
